<template>
  <div style="padding-bottom: 120px;">
    <div class="xh-topbg">
      <van-nav-bar
        title="上海合合信息有限..."
        left-arrow
        fixed
        placeholder
        @click-left="onClickLeft"
        @click-right="onClickRight">
        <template #right>
          <van-icon name="gengduo1" size="28" />
        </template>
      </van-nav-bar>
      <div class="detail-cont">
      <div class="job-header company-header">
        <div class="company-info">
          <img src="../../../assets/img/logo1.jpg"/>
          <div class="company-inner">
            <h2>上海合合信息有限公司</h2>
            <div class="about"><span>上市公司·20-99人·金融</span><button>关注</button></div>
          </div>
        </div>
        <ul class="condition">
          <li>
            <van-icon name="shijian"></van-icon>
            <span>招若干人</span>
          </li>
          <li>
            <van-icon name="jiaban"></van-icon>
            <span>双休</span>
          </li>
          <li>
            <van-icon name="jiaban"></van-icon>
            <span>偶尔加班</span>
          </li>
        </ul>
        <div class="title-02">
          <h3>企业福利</h3>
          <span class="icon-more" @click="showMore" v-if="welfarelist.length > 5" :class="{'active':active}" >{{brandFold?'查看全部':'收起'}}</span>
        </div>
        <ul class="welfare">
          <li v-for="item in showMoreList" :key="item.index">{{item.welfare}}</li>
        </ul>
      </div>
      <ul class="edit-icon">
        <li>
          <van-icon name="fenxiang"></van-icon>
          <span>分享</span>
        </li>
        <li>
          <van-icon name="jubao"></van-icon>
          <span>举报</span>
        </li>
        <!--<li>-->
          <!--<van-icon name="eye-close"></van-icon>-->
          <!--<span>屏蔽</span>-->
        <!--</li>-->
        <li>
          <van-icon name="quxiaopingbi"></van-icon>
          <span>取消屏蔽</span>
        </li>
      </ul>
      <div class="title-01">
        <h2>公司视频</h2>
      </div>
      <video-player  class="video-player vjs-custom-skin"
                     ref="videoPlayer"
                     :playsinline="true"
                     :options="playerOptions"
      ></video-player>
      <div class="title-01">
        <h2>公司环境</h2>
      </div>
      <ul class="photo-list">
        <li v-for="item in photos" :key="item.index"><img :src="item.photo"/></li>
      </ul>
      <div class="line"></div>
      <div class="title-01">
        <h2>公司简介</h2>
      </div>
      <div class="intr">
        <p>【合合信息有话对你说】   </p>
        <p>合合信息衷心邀请积极向上有自驱力，热爱技术有钻研心，心系团队有责任感的你加入我们，人工智能与大数据的未来由我们共创。</p>
        <p>【合合信息介绍】</p>
        <p>上海合合信息科技发展有限公司成立于2006年，经过十余年奋斗与发展，合合信息已成长为国内领先的人工智能&大数据提供商。我们在人工智能、商业大数据、模式识别、深度学习等领域拥有独特优势。合合信息拥有百余项全球发明专利，是人工智能场景文字识别领域全球独角兽公司。 合合信息作为移动互联网商务应用领域深…</p>
        <router-link to=""
          href="#" title="查看全部"> 查看全部 </router-link>
      </div>
      <div class="line"></div>
      <div class="title-01">
        <h2>公司地址</h2>
      </div>
      <div class="map">
        <div class="location">
          <van-icon name="weizhi"></van-icon> <span>上海市嘉定区上海捷新动力电池系统有限公司 585号</span>
        </div>
      </div>
    </div>
    </div>
    <!--上拉在招职位-->
    <transition name="fade">
      <div class="fixed-company-detail"
           :class="{'active':poptop}" >
      <!--<div class="fixed-company-detail" :style="{ top: top + '%' }" :class="{'active':poptop}" >-->
        <!--<v-touch v-swipeup="(e)=>vueTouch('上滑',e)">-->
          <!--<button class="more-job" @click="toggleMoreJob"></button>-->
        <!--</v-touch>-->
        <!--<v-touch-->
          <!--v-touch:pan="onPan"-->
          <!--v-touch-options:pan="{ direction: 'horizontal', threshold: 100 }">-->
          <!--<button class="more-job" @click="toggleMoreJob"></button>-->
        <!--</v-touch>-->
        <!--<div class="box"-->
             <!--v-tap="(e)=>vueTouch('点击',e)"-->
             <!--v-longtap="(e)=>vueTouch('长按',e)"-->
             <!--v-swipeleft="(e)=>vueTouch('左滑',e)"-->
             <!--v-swiperight="(e)=>vueTouch('右滑',e)"-->
             <!--v-swipeup="(e)=>vueTouch('上滑',e)"-->
             <!--v-swipedown="(e)=>vueTouch('下滑',e)">-->
          <!--<button class="more-job" @click="toggleMoreJob"></button>-->
        <!--</div>-->
        <v-touch v-on:panmove="panmove" v-on:panend="panend" v-on:panstart="panstart" v-on:swipeup="onSwipeLeft">
          <button class="more-job  swiper-wrapper" @click=""></button>
        </v-touch>

        <!--<v-touch class="controller">-->
          <!--<button class="more-job  swiper-wrapper" @click="toggleMoreJob"></button>-->
        <!--</v-touch>-->
        <h3>在招职位 <small>(26)</small></h3>
        <van-dropdown-menu class="filter filter-popup" active-color="#1C54CF">
          <van-dropdown-item v-model="jobType" :options="jobTypeList" />
          <van-dropdown-item v-model="area" :options="areaList" />
          <van-dropdown-item title="仅看急招" @open=""/>
          <van-dropdown-item title="智能筛选" @open="showFilterPop"/>
        </van-dropdown-menu>
        <ul class="job-list">
          <li v-for="item in jobs" :key="item.index" @click="jobDetail">
            <div class="detail-info">
              <div class="info-header">
                <h3>{{item.title}} <small>急</small> </h3>
                <span>{{item.wages}}</span>
              </div>
              <ul class="conditionList">
                <li v-for="condition in item.conditionList" :key="condition.index">
                  {{condition.detail}}
                </li>
              </ul>
              <ul class="feature">
                <li v-for="feature in item.featurelist" :key="feature.index">
                  {{feature.detail}}
                </li>
              </ul>
              <div class="contact">
                <div class="person">
                  <img :src='item.person'>
                  <span>{{item.name}}</span>
                </div>
                <div class="place">
                  {{item.place}}
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </transition>
    <van-share-sheet
      v-model="showShare"
      title="我要分享"
      :options="options"
      @select="onReport"
    />
    <!--弹出举报-->
    <transition name="fade">
      <div class="filter-cont report" v-show="reportPop">
        <div class="pop-header">
          <van-icon name="closed" @click="hiddenReportPop"></van-icon>
          <h2>举报</h2>
        </div>
        <h3>举报理由 </h3>
        <ul class="filter-list">
          <li v-for="(item,index) in reason" :key="item.index" :class="{checked:index==r}" @click="selectReason(index)"><span>{{item}}</span></li>
        </ul>
        <h3>举报说明 </h3>
        <textarea class="textarea" placeholder="请输入您的反馈，我们将不断为您改进，一经核实
将尽快联系您～" name="" id="" cols="30" rows="10">

        </textarea>
        <van-uploader v-model="fileList" multiple />
        <div class="fixed-bottom">
          <van-button type="primary" class="btn-blue" color="linear-gradient(to right top, #2F72F6,#1C54CF)" round>提 交</van-button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  import Swiper from 'swiper'
  let pageHight= 0;

export default {
  name: 'companyDetail',

      data() {
    return {
      differ:0,
      top:0,
      startMove:0,
      brandFold: true,
      active: true,
      more: '',
      poptop: false,
      filterPop: false,
      r: 0,
      jobType: '0',
      area: '01',
      reportPop: false,
      showShare: false,
      fileList: [
        { url: 'https://img.yzcdn.cn/vant/leaf.jpg' },
        // Uploader 根据文件后缀来判断是否为图片文件
        // 如果图片 URL 中不包含类型信息，可以添加 isImage 标记来声明
        { url: 'https://cloud-image', isImage: true }
      ],
      selectReason(index) {
        this.r = index
      },
      areaList: [
        { text: '区镇街道', value: '01' },
        { text: '全嘉定', value: 'a' },
        { text: '马陆镇', value: 'b' },
        { text: '江桥', value: 'c' },
        { text: '南翔镇', value: 'd' },
        { text: '销徐行量排序', value: 'e' },
        { text: '外冈', value: 'f' },
        { text: '安亭', value: 'g' }
      ],
      jobTypeList: [
        { text: '职位类型', value: '0' },
        { text: '类型2', value: '1' },
        { text: '类型3', value: '2' }
      ],
      options: [
        [
          { name: '微信', icon: require('../../../assets/img/share/wechat.png') },
          { name: '朋友圈', icon: require('../../../assets/img/share/pyq.png') },
          { name: 'QQ', icon: require('../../../assets/img/share/qq.png') },
          { name: '微博', icon: require('../../../assets/img/share/weibo.png') }
        ],
        [
          { name: '我要举报', icon: require('../../../assets/img/share/jubao.png') },
          { name: '屏蔽公司', icon: require('../../../assets/img/share/pingbi.png') }
        ]
      ],
      photos: [
        {
          photo: require('../../../assets/img/photo1.png')
        },
        {
          photo: require('../../../assets/img/photo2.png')
        }
      ],
      featurelist: [
        {
          detail: '上海航天电子有限公司'
        }, {
          detail: '1000人以上'
        }, {
          detail: '移动互联网'
        }
      ],
      reason: ['广告', '政治敏感内容', '资质造假', '人身攻击', '传 销', '以培训名义招生', '职位地址虚假', '其他', '索取隐私'],

      welfarelist: [
        {
          welfare: '五险一金'
        }, {
          welfare: '包吃'
        }, {
          welfare: '包住'
        }, {
          welfare: '每周双休'
        },
        {
          welfare: '五险一金'
        }, {
          welfare: '包吃'
        }, {
          welfare: '包住'
        }, {
          welfare: '每周双休'
        }
      ],
      jobs: [
        {
          title: '组件工程师维修班长',
          wages: '8000-12000',
          person: require('@/assets/img/user.png'),
          name: '刘经理·人事',
          place: '嘉定新城',
          featurelist: [
            {
              detail: '上海航天电子有限公司'
            }, {
              detail: '1000人以上'
            }, {
              detail: '移动互联网'
            }
          ],
          conditionList: [
            {
              detail: '3-5年'
            }, {
              detail: '学历不限'
            }
          ]
        },
        {
          title: '组件工程师维修班长',
          wages: '8000-12000',
          person: require('@/assets/img/user.png'),
          name: '刘经理·人事',
          place: '嘉定新城',
          featurelist: [
            {
              detail: '上海航天电子有限公司'
            }, {
              detail: '1000人以上'
            }, {
              detail: '移动互联网'
            }
          ],
          conditionList: [
            {
              detail: '3-5年'
            }, {
              detail: '学历不限'
            }
          ]
        },
        {
          title: '组件工程师维修班长',
          wages: '8000-12000',
          person: require('@/assets/img/user.png'),
          name: '刘经理·人事',
          place: '嘉定新城',
          featurelist: [
            {
              detail: '上海航天电子有限公司'
            }, {
              detail: '1000人以上'
            }, {
              detail: '移动互联网'
            }
          ],
          conditionList: [
            {
              detail: '3-5年'
            }, {
              detail: '学历不限'
            }
          ]
        },
        {
          title: '组件工程师维修班长',
          wages: '8000-12000',
          person: require('@/assets/img/user.png'),
          name: '刘经理·人事',
          place: '嘉定新城',
          featurelist: [
            {
              detail: '上海航天电子有限公司'
            }, {
              detail: '1000人以上'
            }, {
              detail: '移动互联网'
            }
          ],
          conditionList: [
            {
              detail: '3-5年'
            }, {
              detail: '学历不限'
            }
          ]
        }
      ],
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度
        autoplay: false, // 如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          src: 'http://service.shanghai.gov.cn/videoFTP/kankanews/20201109/xwbd_e66180d83b26944bb58eaa47dd98da32/xwbd_e66180d83b26944bb58eaa47dd98da32.mp4', // 路径
          type: 'video/mp4' // 类型
        }, {
          src: '//path/to/video.webm',
          type: 'video/webm'
        }],
        poster: 'http://service.shanghai.gov.cn/videoFTP/kankanews/20201109/xwbd_e66180d83b26944bb58eaa47dd98da32/xwbd_e66180d83b26944bb58eaa47dd98da32.jpg', // 你的封面地址
        // width: document.documentElement.clientWidth,
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true // 全屏按钮
        }
      }
    }
  },
  mounted(){
    pageHight=document.documentElement.clientHeight;
    console.log("pageHight",pageHight)
    this.top=pageHight*0.85;
  },
  computed: {
    showMoreList: {
      get: function () {
        if (this.brandFold) {
          if (this.welfarelist.length < 5) {
            return this.welfarelist
          }
          let newList = []
          for (var i = 0; i < 5; i++) {
            let item = this.welfarelist[i]
            newList.push(item)
          }
          return newList
        }
        return this.welfarelist
      },
      set: function (val) {
        this.showMoreList = val
      }
    }
  },
  methods: {
    panend(e){
      let needChange= pageHight*0.3;
      if(this.startMove>e.center.y){

        if(e.center.y-this.startMove>needChange){
          this.poptop=false
          this.top=pageHight*0.85
        }else{
          this.poptop=true
        }
      }else{
        if(e.center.y-this.startMove>needChange){

          this.poptop=false
          this.top=pageHight*0.85
        }else{
          this.poptop=true
        }

      }
    },
    panstart(e){

      this.startMove=0;
      this.differ=0;
      this.top=0;
      if(this.poptop){
        this.poptop=false;
        this.differ= Math.abs(60- e.center.y)
      }else{
        this.differ= pageHight*0.85- e.center.y
      }

      this.startMove=e.center.y;
    },
    panmove(e){
      this.top=this.differ+e.center.y;
    },

    onSwipeLeft(e,e2){
      console.log("左滑",e,e2);
    },
    onPan(e,e1){
      console.log("onpan",e,e1);
    },
    vueTouch(type,e){
      console.log("type",type,e);
    },
    onClickLeft() {
      this.$router.go(-1)
    },
    onClickRight() {
      this.showShare = true
    },
    toggleClass() {
      this.active = !this.active
    },
    showMore() {
      this.brandFold = !this.brandFold
      this.active = !this.active
    },
    hiddenReportPop() {
      this.reportPop = false
    },
    onReport() {
      this.reportPop = true
      this.showShare = false
    },
    toggleMoreJob() {
      this.poptop = !this.poptop
    },
    jobDetail() {
      this.$router.push({ path: '/demo/jobDetail' })
    },
    showFilterPop() {
      this.filterPop = true
    }
  },
}
</script>

<style lang="less" scoped>
  /deep/.van-nav-bar{
    background: #1C54CF;
    .van-nav-bar__title,i{
      color:#fff;
      font-weight: normal;
    }
  }
  /deep/.van-share-sheet__title{
    font-size: 14px;
    color:#ADB0B6;
  }
  /deep/.van-share-sheet__options{
    .van-share-sheet__option{
      width: 25%;
    }
    .van-share-sheet__icon{
      width: auto;
      height: 30px;
    }
  }
  /deep/.van-uploader{
    margin:10px 16px;
    .van-uploader__preview-delete-icon{
      top: -3px;
    }
  }
  /deep/.video-player{
    margin:10px 16px;
    border-radius: 10px;
  }
  /deep/.video-js.vjs-fluid,/deep/.vjs-poster, /deep/.video-js.vjs-16-9, /deep/.video-js.vjs-4-3,/deep/.video-js .vjs-tech{
    border-radius: 16px;
  }
  .textarea{
    width:100%;
    min-height: 170px;
    background: #F8F9FB;
    border-radius: 4px;
    border: none;
    margin:2px 16px;
    padding:16px;
    font-size: 14px;
    &::-webkit-input-placeholder{
      color:#ccc
    }
  }
  .fixed-bottom{
    padding:10px 16px 20px;
    button{
      flex:1;
    }
  }
  .job-list{
    margin-left: 0;
    margin-right: 0;
    &>li{
      padding:6px 16px;
      border-bottom: 8px solid #F7F7F7;
      &:last-child{
        border-bottom: 0;
      }
    }
  }
  /deep/.van-popup{
    border-radius: 0;
  }


</style>
